const QUERIES = {
  CATEGORYS_LIST: 'categorys-list',
  POSTS_LIST: 'posts-list',
  USERS_LIST: 'users-list',
}

export {QUERIES}
